import { render, staticRenderFns } from "./Analiza.vue?vue&type=template&id=c10fbf08&scoped=true&"
import script from "./Analiza.vue?vue&type=script&lang=js&"
export * from "./Analiza.vue?vue&type=script&lang=js&"
import style0 from "./Analiza.vue?vue&type=style&index=0&id=c10fbf08&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10fbf08",
  null
  
)

export default component.exports